


























import EditionModal from "../core/Modals/EditionModal.vue";
import JournalEntryModalDisplay from "./EntryModalPartials/JournalEntryModalDisplay.vue";
import { JournalApi } from "../api/JournalApi";
import { JournalEntry } from "../models/JournalEntry";
import JournalEntryModalEdit from "./EntryModalPartials/JournalEntryModalEdit.vue";

export default {
    name: "JournalEntryModal",
    components: {
        JournalEntryModalEdit,
        JournalEntryModalDisplay,
        EditionModal,
    },
    props: {
        entryId: Number,
        forceEditing: Boolean,
        isNew: Boolean,
        parent: JournalEntry,
        defaultText: String,
        // Catégorie de l'onglet actif du journal ("all" => général)
        defaultCategory: [Number, String],
    },
    data() {
        return {
            showModal: false,
            entry: null,
            fetching: true,
            editing: false,
            blockSaving: false,
            JournalApi: new JournalApi(),
        };
    },
    watch: {
        entryId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal);
            if (self.showModal) {
                self.fetching = true;
                self.JournalApi.get(newVal).then(function (res) {
                    self.entry = res;
                    self.fetching = false;
                });
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.entry = new JournalEntry({});
                    if (this.parent) {
                        this.entry.parent_id = this.parent.id;
                    }
                    if (
                        this.defaultCategory != null &&
                        this.defaultCategory !== "all"
                    ) {
                        this.entry.category = this.defaultCategory;
                    }
                    this.creationModal();
                }
            },
        },
        forceEditing: function (newVal) {
            this.editing = newVal;
        },
    },
    methods: {
        closeModal: function (data): void {
            this.showModal = false;
            this.$emit("close-modal", data);
        },
        saveEntry: function (): Promise<JournalEntry> {
            var self = this;

            return self.JournalApi.save(self.entry).then(function (res) {
                self.$emit("data-saved", self.entry);
                return res;
            });
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
            if (this.defaultText) {
                this.entry.description = this.defaultText;
            }
        },
        onFileUpload: function (uploading): void {
            this.blockSaving = uploading;
        },
    },
};
